import { useTheme } from "@mui/material/styles";
import { SVGProps } from "react";

const HMSmallLogo = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  return (
    <img
      src="/images/hm.png" 
      width="30px"
      height="30px"
      style={{ marginLeft: 10, width: "30px", height: "30px", borderRadius: "15px" }}
    />
  );
};

export default HMSmallLogo;
